import React, { useRef, useState, useEffect, useCallback, Suspense } from "react";
import Buttons from "../../../components/ui/button/Buttons";
import FormCreator from "../../../components/forms/FormCreator";
import FinalMolGrid from "../../../components/FinalMolGrid/FinalMolGrid";
import { PaymentApprovalList } from "../data/PaymentApprovalList.Data";
import { useAcceptAndApprovedIPASApplicationMutation, useAddPaymentReconciliationDetailByAdminMutation, useLazyGetPaymenetApprovalDetailsByIdQuery, useLazyGetPaymenetApprovalDetailsListQuery, useLazyAcceptTotalPaidAmountInReconcilationQuery } from "../../../app/services/PaymentReconciliation/PaymentReconciliationApi";
import { useLazyGetPDFQuery } from "../../../app/services/common/commonServiceApi";
import { PaymentApprovalData } from "../data/PaymentApproval.Data";
import { saveAs } from "file-saver";
import { setAllDropDownFieldsBatch } from "../../../utils/FormFields/FieldsSetting/SetFieldSetting";
import SwalAlert from "../../../services/swalService/SwalService";
import { getImageWebUrl } from "../../../utils/AppSetting";
import { getAuditContext } from "../../../lib/authenticationLibrary";

const EditPaymentReconciliation = (props) => {
    const editPaymentReconciliationRef = useRef();
    const editReconsilationListDetailsRef = useRef();
    const [imageProof, setImageProf] = useState(null);
    const [dataSource, setDataSource] = useState();
    const [getPDF] = useLazyGetPDFQuery();
    const { error, success } = SwalAlert();
    const audit = getAuditContext();
    const [getPaymenetApprovalDetailsById, { isSuccess: isApprovalDetailsSuccess, isLoading: isApprovalDetailsLoading, data: paymenetApprovalDetailsData }] = useLazyGetPaymenetApprovalDetailsByIdQuery();
    const [addPaymentDetial, { isSuccess: isAddPaymentDetialSuccess, isLoading: isAddPaymentDetialLoading, data: paymenetAddPaymentDetialData }] = useAddPaymentReconciliationDetailByAdminMutation();
    const [getPaymentApprovalList, { isSuccess: isGetPaymentApprovalListSuccess, isLoading: isGetPaymentApprovalListLoading, data: paymenetGetPaymentApprovalListData }] = useLazyGetPaymenetApprovalDetailsListQuery();
    const [approvePaymentReconciliation, { isSuccess: isApprovePaymentReconciliationSuccess, isLoading: isApprovePaymentReconciliationLoading, data: paymenetApprovePaymentReconciliationData }] = useAcceptAndApprovedIPASApplicationMutation();
    const [acceptTotalPaidAmountInReconcilation, { isSuccess: isacceptTotalPaidAmountInReconcilationSuccess, isLoading: isacceptTotalPaidAmountInReconcilationLoading, data: paymenetacceptTotalPaidAmountInReconcilationData }] = useLazyAcceptTotalPaidAmountInReconcilationQuery();

    const dropdownFields = [
        { dropdownName: "BankInformation", fieldId: "bankInformation" },
    ];

    useEffect(() => {
        if (props) {
            getPaymenetApprovalDetailsById(Number(props.paymentProofDetails.paymentProofId))
            let membershipPaymentId = props?.paymentProofDetails?.membershipPaymentId > 0 ? props?.paymentProofDetails?.membershipPaymentId : 0
            let bookingid = props?.paymentProofDetails?.bookingId > 0 ? props?.paymentProofDetails?.bookingId : 0

            let request = {
                membershipPaymentId: membershipPaymentId,
                bookingid: bookingid
            }
            getPaymentApprovalList(request);
        }
    }, [props]);

    useEffect(() => {
        if (!isApprovalDetailsLoading && isApprovalDetailsSuccess && paymenetApprovalDetailsData) {
            if (!paymenetApprovalDetailsData?.paymentProofFileName?.split('.')?.pop()?.includes('pdf')) {
                setImageProf(`${getImageWebUrl + paymenetApprovalDetailsData?.paymentProofEncryptedFileName}`)
            }
            else if (imageProof) {
                setImageProf(null);
            }
        };
    }, [isApprovalDetailsLoading, isApprovalDetailsSuccess, paymenetApprovalDetailsData]);

    useEffect(() => {
        if (props?.taskListDropDownData)
            setAllDropDownFieldsBatch(PaymentApprovalData, dropdownFields, props.taskListDropDownData);
    }, [props?.taskListDropDownData])

    useEffect(() => {
        if (!isAddPaymentDetialLoading && isAddPaymentDetialSuccess && paymenetAddPaymentDetialData) {
            if (paymenetAddPaymentDetialData?.keyId > 0) {
                success("Payment details added successfully", "Success");
                handleClose();
                props.getReconsilationRecors();
            }
        };
    }, [isAddPaymentDetialLoading, isAddPaymentDetialSuccess, paymenetAddPaymentDetialData]);

    useEffect(() => {
        if (!isacceptTotalPaidAmountInReconcilationLoading && isacceptTotalPaidAmountInReconcilationSuccess && paymenetacceptTotalPaidAmountInReconcilationData) {
            success("Payment details added successfully", "Success");
            handleClose();
            props.getReconsilationRecors();
        };
    }, [isacceptTotalPaidAmountInReconcilationLoading, isacceptTotalPaidAmountInReconcilationSuccess, paymenetacceptTotalPaidAmountInReconcilationData]);

    useEffect(() => {
        if (!isGetPaymentApprovalListLoading && isGetPaymentApprovalListSuccess && paymenetGetPaymentApprovalListData) {
            if (paymenetGetPaymentApprovalListData.length > 0)
                setDataSource(paymenetGetPaymentApprovalListData);
        };
    }, [isGetPaymentApprovalListLoading, isGetPaymentApprovalListSuccess, paymenetGetPaymentApprovalListData]);

    useEffect(() => {
        if (!isApprovePaymentReconciliationLoading && isApprovePaymentReconciliationSuccess && paymenetApprovePaymentReconciliationData) {
            if (paymenetApprovePaymentReconciliationData.ipasMemberId > 0) {
                success("Payment accepted successfully", "Success");
                handleClose();
                window.location.reload();
            }
        };
    }, [isApprovePaymentReconciliationLoading, isApprovePaymentReconciliationSuccess, paymenetApprovePaymentReconciliationData]);

    // const handleDownload = async () => {
    //     if (paymenetApprovalDetailsData?.paymentProofEncryptedFileName) {
    //         let extention = paymenetApprovalDetailsData?.paymentProofEncryptedFileName?.split('.').pop();
    //         const request = {
    //             fileName: paymenetApprovalDetailsData?.paymentProofEncryptedFileName
    //         }
    //         if (extention.includes('pdf')) {
    //             const response = await getPDF(request);
    //             saveAs(response?.data?.fileData, paymenetApprovalDetailsData?.paymentProofEncryptedFileName);
    //         }
    //         else if (extention.includes('png')) {
    //             const response = await getPDF(request);
    //             saveAs(response?.data?.fileData, paymenetApprovalDetailsData?.paymentProofEncryptedFileName);
    //         }
    //         else if (extention.includes('jpg')) {
    //             const response = await getPDF(request);
    //             saveAs(response?.data?.fileData, paymenetApprovalDetailsData?.paymentProofEncryptedFileName);
    //         }
    //         else if (extention.includes('jpeg')) {
    //             const response = await getPDF(request);
    //             saveAs(response?.data?.fileData, paymenetApprovalDetailsData?.paymentProofEncryptedFileName);
    //         }
    //         else {
    //             return;
    //         }
    //     }
    // }

    const handleDownload = async () => {
        const { paymentProofEncryptedFileName: fileName, paymentProofFileName: originalName } = paymenetApprovalDetailsData || {};
        debugger
        if (!(fileName && originalName)) return error("File not found or invalid");

        const extention = originalName.split('.').pop()?.toLowerCase();
        if (['pdf', 'png', 'jpg', 'jpeg'].includes(extention)) {
            try {
                const response = await getPDF({ fileName: fileName }).unwrap();
                return response ? saveAs(response?.fileData, originalName) : error("Invalid file data");
            } catch {
                return error("Error while downloading file");
            }
        }
        error("Unsupported file format");
    };

    const handleClose = () => {
        props.closeModel();
    };

    const handleAdd = () => {
        const reconciliationFormData = editPaymentReconciliationRef?.current?.getFormData();
        if (!reconciliationFormData) {
            return error("Please fill in all mandatory fields.", "Error");
        }
        const request = {
            PaymentProofId: props?.paymentProofDetails?.paymentProofId,
            MembershipPaymentId: props?.paymentProofDetails?.membershipPaymentId > 0 ? props?.paymentProofDetails?.membershipPaymentId : 0,
            BookingId: props?.paymentProofDetails?.bookingId > 0 ? props?.paymentProofDetails?.bookingId : 0,

            BankInformationId: reconciliationFormData?.bankInformation?.value,
            AmountCollected: Number(reconciliationFormData?.amountCollected),
            AmountCollectedDate: reconciliationFormData?.amountCollectedDate,
            CreatedBy: audit.adminUserId,
            CreatedAppId: audit.appId
        }
        if (Number(request.AmountCollected) > Number(paymenetApprovalDetailsData?.amountToBePaid)) {
            error("Can not add amount higher then amount to be paid!", "Error")
            return;
        }
        else if (Number(request.AmountCollected) < 0) {
            return error("Can not add amount less then 0!", "Error")
        }
        addPaymentDetial(request);
    }

    const handleAccept = () => {
        if (props?.paymentProofDetails?.membershipPaymentId > 0) {
            const request = {
                IPASMemberId: props?.paymentProofDetails?.ipasMemberId,
                MembershipPaymentId: props?.paymentProofDetails?.membershipPaymentId,
                ApplicationTaskListId: props?.paymentProofDetails?.taskListId,
                CreatedBy: audit.adminUserId,
                CreatedAppId: audit.appId
            }
            approvePaymentReconciliation(request);
        }
        else {
            const request = {
                BookingId: props?.paymentProofDetails?.bookingId,
                CreatedBy: audit.adminUserId,
                CreatedAppId: audit.appId
            }
            acceptTotalPaidAmountInReconcilation(request);
        }
    }
    return (
        <div>
            <div className="d-flex align-items-start justify-content-between">
                <div className="mb-3">
                    {paymenetApprovalDetailsData?.paymentProofEncryptedFileName && <h5 className="page-title">Payment Proof: {paymenetApprovalDetailsData?.paymentProofEncryptedFileName?.split("\\")?.pop()}</h5>}
                    {imageProof && paymenetApprovalDetailsData?.paymentProofEncryptedFileName?.split(".")?.pop() !== "pdf" && (
                        <img src={imageProof} className="img-fluid" />
                    )}
                    <h5 className="page-title">Comments: {paymenetApprovalDetailsData?.comments}</h5>
                </div>
                <div className="">
                    <Buttons
                        buttonText="Download"
                        buttonTypeClassName="theme-btn btn"
                        onClick={handleDownload}
                        isLoading={false}
                    />
                </div>
            </div>
            {paymenetApprovalDetailsData?.amountToBePaid > 0 && (paymenetApprovalDetailsData?.paymentProofStatusId === '1' || paymenetApprovalDetailsData?.paymentProofStatusId === 1) &&
                <>
                    <FormCreator
                        config={PaymentApprovalData}
                        ref={editPaymentReconciliationRef}
                        key={false}
                    />
                    <div className="btn-sec">
                        <Buttons
                            buttonText="Add"
                            buttonTypeClassName="theme-btn btn mb-4 mt-2"
                            onClick={handleAdd}
                            isLoading={isAddPaymentDetialLoading}
                        />
                    </div>
                </>
            }
            <div className="d-flex justify-content-between">
                <h5 className="page-title">Total Amount : ${paymenetApprovalDetailsData?.totalAmount?.toFixed(2)}</h5>
                <h5 className="page-title">Amount to be Paid : ${paymenetApprovalDetailsData?.amountToBePaid?.toFixed(2)}</h5>
            </div>
            <div className="paymentapproval-table">
                <FinalMolGrid
                    ref={editReconsilationListDetailsRef}
                    configuration={PaymentApprovalList}
                    dataSource={dataSource} />
            </div>
            {paymenetApprovalDetailsData?.amountToBePaid === 0 && (paymenetApprovalDetailsData?.paymentProofStatusId === '2' || paymenetApprovalDetailsData?.paymentProofStatusId === 2) &&
                <div className="btn-sec">
                    <Buttons
                        buttonText="Accept"
                        buttonTypeClassName="theme-btn btn mb-4 mt-2"
                        onClick={handleAccept}
                        isLoading={isApprovePaymentReconciliationLoading || isacceptTotalPaidAmountInReconcilationLoading}
                    />
                </div>
            }
        </div >
    )
};

export default EditPaymentReconciliation;
